export const environment = {
  production: false,
  apiBaseUrl: 'https://driversafety-api-qa.azurewebsites.net/api',
  onlineCourseClientUrl:
    'https://nscsandbox.thoughtindustries.com/kane-county-bar-association',
};
